
export const showToast = (severity, message, life = 3000) => {
  if (import.meta.client) {
    $().$toast.add({ severity, summary: 'Thông báo', detail: message, life: life });
  }
};


export const chartTheme = {
  theme1: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#33B2DF', '#546E7A', '#D4526E', '#13D8AA', '#A5978B', '#2B908F', '#F9A3A4', '#90EE7E', '#FA4443', '#69D2E7'],
  theme2: ['#3F51B5', '#03A9F4', '#4CAF50', '#F9CE1D', '#FF9800', '#2B908F', '#F9A3A4', '#90EE7E', '#FA4443', '#69D2E7', '#F86624', '#EA3546', '#662E9B', '#C5D86D', '#4ECDC4'],
  theme3: ['#33B2DF', '#546E7A', '#D4526E', '#13D8AA', '#A5978B', '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#449DD1', '#F86624', '#EA3546', '#662E9B', '#C5D86D'],
  theme4: ['#2B908F', '#F9A3A4', '#90EE7E', '#FA4443', '#69D2E7', '#3F51B5', '#03A9F4', '#4CAF50', '#F9CE1D', '#FF9800', '#33B2DF', '#546E7A', '#D4526E', '#13D8AA', '#A5978B'],
  theme5: ['#449DD1', '#F86624', '#EA3546', '#662E9B', '#C5D86D', '#4ECDC4', '#C7F464', '#81D4FA', '#546E7A', '#FD6A6A', '#F9A3A4', '#90EE7E', '#FA4443', '#69D2E7', '#3F51B5'],
  theme6: ['#D7263D', '#1B998B', '#2E294E', '#F46036', '#E2C044', '#662E9B', '#F86624', '#F9C80E', '#EA3546', '#43BCCD', '#3F51B5', '#03A9F4', '#4CAF50', '#F9CE1D', '#FF9800'],
}


